// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__16BTB","load2":"Spinner_load2__rWQCr"};